import {
  GraduationCap, Heart, PartyPopper, BookOpen, Shield,
  Calendar, Megaphone, Award, Flag, Sun,
} from 'lucide-react';
import type { FC } from 'react';

export interface ComunicadoTemplate {
  id: string;
  nome: string;
  descricao: string;
  categoria: 'INSTITUCIONAL' | 'OPERACIONAL' | 'TEMPLATE';
  tipo: string;
  icon: FC<{ size?: number }>;
  color: string;
  titulo: string;
  corpo: string;
  tags: string[];
}

export const TEMPLATES_BANCO: ComunicadoTemplate[] = [
  {
    id: 'dia-maes', nome: 'Dia das Maes', descricao: 'Homenagem institucional para o Dia das Maes',
    categoria: 'TEMPLATE', tipo: 'EVENTO', icon: Heart, color: '#ec4899',
    titulo: 'Feliz Dia das Maes!',
    corpo: 'A Prefeitura Municipal parabeniza todas as maes da nossa rede de ensino. Voces sao a base da educacao dos nossos alunos. Agradecemos pelo empenho e dedicacao diarios. Feliz Dia das Maes!',
    tags: ['comemorativo', 'maio'],
  },
  {
    id: 'festa-junina', nome: 'Festa Junina', descricao: 'Convite para a Festa Junina das escolas',
    categoria: 'TEMPLATE', tipo: 'EVENTO', icon: PartyPopper, color: '#f59e0b',
    titulo: 'Festa Junina 2026 — Venha celebrar!',
    corpo: 'Convidamos todas as familias para a Festa Junina da nossa rede municipal! Teremos barraquinhas, quadrilha, brincadeiras e muita diversao. Contamos com a presenca de todos!',
    tags: ['comemorativo', 'junho'],
  },
  {
    id: 'volta-aulas', nome: 'Volta as Aulas', descricao: 'Comunicado de inicio do periodo letivo',
    categoria: 'TEMPLATE', tipo: 'AVISO', icon: BookOpen, color: '#2563eb',
    titulo: 'Volta as Aulas — Novo Periodo Letivo',
    corpo: 'Informamos que as aulas do novo periodo letivo iniciam no dia [DATA]. Pedimos que os responsaveis garantam a presenca dos alunos desde o primeiro dia. A educacao comeca com pontualidade!',
    tags: ['operacional', 'semestre'],
  },
  {
    id: 'reuniao-pais', nome: 'Reuniao de Pais', descricao: 'Convocacao para reuniao de pais e mestres',
    categoria: 'OPERACIONAL', tipo: 'REUNIAO', icon: Calendar, color: '#8b5cf6',
    titulo: 'Reuniao de Pais e Mestres',
    corpo: 'Convidamos os responsaveis para a Reuniao de Pais e Mestres que acontecera no dia [DATA] as [HORA]. Sua presenca e fundamental para acompanhar o desempenho escolar do seu filho(a).',
    tags: ['operacional', 'bimestral'],
  },
  {
    id: 'campanha-saude', nome: 'Campanha de Saude', descricao: 'Vacinacao ou campanha de saude nas escolas',
    categoria: 'INSTITUCIONAL', tipo: 'AVISO', icon: Shield, color: '#10b981',
    titulo: 'Campanha de Saude nas Escolas',
    corpo: 'A Secretaria de Saude, em parceria com a Secretaria de Educacao, realizara uma campanha de [TIPO] nas escolas municipais. Solicitamos que os responsaveis enviem a carteira de vacinacao dos alunos.',
    tags: ['saude', 'institucional'],
  },
  {
    id: 'obra-escola', nome: 'Obra na Escola', descricao: 'Informativo sobre obras e melhorias',
    categoria: 'INSTITUCIONAL', tipo: 'AVISO', icon: Megaphone, color: '#0891b2',
    titulo: 'Melhorias na Infraestrutura Escolar',
    corpo: 'Informamos que a escola [NOME] passara por obras de melhoria a partir de [DATA]. As aulas seguem normalmente. A Prefeitura investe continuamente na qualidade do ensino.',
    tags: ['infraestrutura', 'institucional'],
  },
  {
    id: 'dia-professor', nome: 'Dia do Professor', descricao: 'Homenagem ao Dia do Professor',
    categoria: 'TEMPLATE', tipo: 'EVENTO', icon: GraduationCap, color: '#7c3aed',
    titulo: 'Feliz Dia do Professor!',
    corpo: 'Hoje celebramos aqueles que transformam vidas pela educacao. A Prefeitura Municipal agradece e homenageia cada professor da nossa rede. Voces sao essenciais! Feliz 15 de outubro!',
    tags: ['comemorativo', 'outubro'],
  },
  {
    id: 'resultado-bimestre', nome: 'Resultado Bimestral', descricao: 'Divulgacao de resultados do bimestre',
    categoria: 'OPERACIONAL', tipo: 'AVISO', icon: Award, color: '#059669',
    titulo: 'Resultados do [N]o Bimestre Disponiveis',
    corpo: 'Informamos que os resultados do [N]o bimestre ja estao disponiveis no aplicativo. Responsaveis podem acompanhar notas, frequencia e observacoes dos professores diretamente pelo sistema.',
    tags: ['operacional', 'bimestral'],
  },
  {
    id: 'feriado', nome: 'Feriado / Recesso', descricao: 'Aviso de feriado ou recesso escolar',
    categoria: 'OPERACIONAL', tipo: 'LEMBRETE', icon: Sun, color: '#f97316',
    titulo: 'Recesso Escolar — [PERIODO]',
    corpo: 'Informamos que nao havera aulas no periodo de [DATA_INICIO] a [DATA_FIM] devido a [MOTIVO]. As aulas retornam normalmente no dia [DATA_RETORNO]. Bom descanso a todos!',
    tags: ['operacional', 'recesso'],
  },
  {
    id: 'matricula', nome: 'Periodo de Matriculas', descricao: 'Abertura do periodo de matriculas',
    categoria: 'INSTITUCIONAL', tipo: 'URGENTE', icon: Flag, color: '#dc2626',
    titulo: 'Matriculas Abertas — Periodo [ANO]',
    corpo: 'A Prefeitura Municipal informa que o periodo de matriculas para [ANO] esta aberto! Procure a escola mais proxima ou acesse o sistema online. Vagas limitadas por unidade.',
    tags: ['institucional', 'matricula'],
  },
];
